// extracted by mini-css-extract-plugin
export default {"container":"Posts_container__XHxkT","posts":"Posts_posts__Aze1R","links":"Posts_links__hmYKb","link":"Posts_link__MNxAJ"};